import { useEntity } from '@backstage/plugin-catalog-react';
import { InfoCard, LinkButton } from '@backstage/core-components';
import { MissingAnnotation } from '../MissingAnnotation.tsx';

export const ChangelogCardMissingAnnotation = () => {
  const { entity } = useEntity();

  return (
    <InfoCard title="Changelog" variant="fullHeight">
      <MissingAnnotation
        annotations={['changelog-name']}
        entity={entity}
        description="Add the annotation to your catalog-info.yaml as shown in the highlighted example below. If the CHANGELOG.md file is located in a different location, you must also include the path in the annotation (e.g. 'path/to/CHANGELOG.md')."
      />
      <LinkButton
        to="https://developer.zeiss.com/catalog/default/component/digital-service-catalog/docs/plugins/"
        color="primary"
        variant="contained"
      >
        Learn more
      </LinkButton>
    </InfoCard>
  );
};
